import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import authImg from "../../assets/images/auth/main.png";
import useWindowSize from "../../hooks/useWindowSize";
import { useAuth } from "../../hooks/useAuth";
import { IconButton, Menu, MenuItem } from "@mui/material";
import langIcon from "../../assets/images/header-footer/language.png";
import i18n from "../../localization/LocalesConfig";

const AuthLayout = (props) => {
  const { currentLang } = useAuth();
  const direction = currentLang === "en" ? "ltr" : "rtl";
  const { width } = useWindowSize();
  const { updateCurrentLang } = useAuth();
  // const langLabel =
  //   localStorage.getItem("preferredLanguage") === "ar" ? "العربية" : "English";
  // const [anchorEl, setAnchorEl] = useState(null);
  const [langEl, setLangEl] = useState(null);

  const languages = [
    {
      label: "English",
      lang: "en",
    },
    {
      label: "العربية",
      lang: "ar",
    },
  ];

  const handleLangMenuOpen = (event) => {
    if (event.currentTarget) {
      setLangEl(event.currentTarget); // Set anchor to the icon button
    }
  };
  // const handleMenuOpen = (event) => {
  //   if (event.currentTarget) {
  //     setAnchorEl(event.currentTarget); // Set anchor to the icon button
  //   }
  // };

  const handleChangeLanguage = (lang) => {
    setLangEl(null); // Always close the menu
    // if (lang === "en" || lang === "ar") {
    localStorage.setItem("preferredLanguage", lang);
    localStorage.setItem("direction", lang === "en" ? "ltr" : "rtl");
    console.log(
      "current lang inside handleChangeLanguage before--------->",
      lang,
    );
    i18n?.changeLanguage(lang);
    console.log(
      "current lang inside handleChangeLanguage after--------->",
      lang,
    );
    updateCurrentLang(lang); // Always update context
    // }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        background: "linear-gradient(to right, #093AED14, #01D7EB14)",
      }}
      dir={direction}
    >
      <Grid item size={{ xl: 7, lg: 7, md: 6, sm: 12, xs: 12 }}>
        <>
          <IconButton sx={{ color: "#000" }} onClick={handleLangMenuOpen}>
            <img
              src={langIcon}
              alt="language"
              width={width > 600 ? 50 : 30}
              height={width > 600 ? 50 : 30}
            />
          </IconButton>
          <Menu
            anchorEl={langEl}
            open={Boolean(langEl)} // Open menu if anchorEl is set
            onClose={() => setLangEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set dropdown position
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: "100px",
                display: "flex",
                justifyContent: "center",
                textAlign: "center", // Set your desired width here
              },
            }}
          >
            {languages && languages?.length > 0 ? (
              languages?.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleChangeLanguage(item.lang)}
                  style={{
                    color: "#004D8A",
                    fontFamily: "Tajawal-Bold",
                    cursor: "pointer",
                  }}
                >
                  {item.label}
                </MenuItem>
              ))
            ) : (
              <MenuItem style={{ textAlign: "center" }}>No Languages</MenuItem>
            )}
          </Menu>
        </>
        {props?.children}
      </Grid>
      {width > 900 && (
        <Grid item size={{ xl: 5, lg: 5, md: 6, sm: 12, xs: 12 }}>
          <img
            src={authImg}
            alt="auth"
            style={{ width: "100%", height: "99vh" }}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default AuthLayout;
